module.exports = __webpack_public_path__ + "static/yellow1-c71078eaa95839e46fa43f7279b91817.png";